import type { Evaluation } from '../App';

// Client-side history. With no backend, roasts live in the browser's
// localStorage instead of Postgres. This keeps the "Previous Roasts" gallery
// and /review/:uuid links working locally (per-browser, not shared across users).

const KEY = 'yrs_roasts';
const MAX_STORED = 100;

export function loadRoasts(): Evaluation[] {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as Evaluation[]) : [];
  } catch {
    return [];
  }
}

export function saveRoast(evaluation: Evaluation): void {
  try {
    const all = loadRoasts().filter((r) => r.evaluation_uuid !== evaluation.evaluation_uuid);
    all.unshift(evaluation);
    localStorage.setItem(KEY, JSON.stringify(all.slice(0, MAX_STORED)));
  } catch {
    // Storage full or unavailable — non-fatal, the roast is still shown.
  }
}

export function getRoast(uuid: string): Evaluation | undefined {
  return loadRoasts().find((r) => r.evaluation_uuid === uuid);
}
